import { API_BASE_URL } from '../configuration/config';
import { BaseService } from './base-service';
import { StatusCodes } from 'http-status-codes';

export class OrdersService extends BaseService {
  /**
   * Singleton instance for orders service
   */
  public static instance = new OrdersService(API_BASE_URL);

  private procurementHardwareTeamMembers?: Promise<string[]>;

  public getProcurementHardwareTeamMembers(): Promise<string[]> {
    this.procurementHardwareTeamMembers ??= this.fetchProcurementHardwareTeamMembers().catch((error) => {
      this.procurementHardwareTeamMembers = undefined;
      throw error;
    });
    return this.procurementHardwareTeamMembers;
  }

  private async fetchProcurementHardwareTeamMembers(): Promise<string[]> {
    const response = await this.fetch('/get-global-hardware-procurement-team');
    if (response.status !== StatusCodes.OK) {
      throw new Error(
        `An error occurred when trying to obtain get the information on Procurement Hardware Team members: ${JSON.stringify(
          response
        )}`
      );
    }

    const jsonResponse = await response.json();
    return jsonResponse;
  }
}
